import settings from '@/settings.json'

export class AppSettings {

  static data: object = {}

  static get(property) {
    if (JSON.stringify(this.data) === JSON.stringify({})) {
      const request = new XMLHttpRequest()
      request.open('GET', settings, false)
      request.send()

      AppSettings.data = JSON.parse(request.responseText)

      return this.data[property]
    } else {
      return AppSettings.data[property]
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/appSettings.ts